import { render } from "./Calendar.vue.js?vue&type=template&id=37551d2a!=!../vue-loader/dist/index.js??ruleSet[0]!./Calendar.vue?vue&type=template&id=37551d2a"
import script from "./Calendar.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Calendar.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__